import React from "react"
import HeaderSection from "shared/Components/Skeleton/HeaderSection"
import { HeaderTopBar } from "shared/Components/Skeleton/TopBar"
import { ExpensesTabs, ExpensesTabsProps } from "./ExpensesTabs"

type MyOrdersHeaderProps = ExpensesTabsProps & Readonly<{
    title: string
    onBackButtonPress: () => void
}>

export function MyOrdersHeader({ title, onBackButtonPress, ...rest }: MyOrdersHeaderProps) {

    return (
        <>
            <HeaderTopBar onBackButtonPress={onBackButtonPress} />
            <HeaderSection title={title}>
                <ExpensesTabs {...rest} />
            </HeaderSection>
        </>
    )
}
